import * as React from 'react'
import {IConstrInputData} from '../../../interfaces/reducers/IConstrImport'
import {IFeatureLayerInfos} from '../../../core/interfaces/reducers'
import {ISourcesDispatcher} from '../../../core/interfaces/dispatchers'
import {updateInputData, updateInputDataLayers} from '../../../dispatchers/appConstrImportDispatcher'
import {AttachmentInfos, AttachmentInfo} from '../../../core/interfaces/models'
import {AttachmentsViewer} from '../../../core/components/Controls/Attachments/AttachmentsViewer2'
import {PlanSelector} from '../../App/PlanSelector'
import OverlayLoader from '../../../core/components/Loading/OverlayLoading'
import {IAppStore} from '../../../interfaces/reducers'
import {connect} from 'react-redux'
import {appSourcesDispatcher} from '../../../dispatchers/appSourcesDispatcher'
import {Feature} from '../../../core/models'
import {validate} from '../../../dispatchers/appEditsImportDispatcher'

interface OwnProps {
  inputData: IConstrInputData
  layerInfos: IFeatureLayerInfos
}

interface ParentProps {}

interface DispatchProps extends ISourcesDispatcher {
  updateInputData: typeof updateInputData
  updateInputDataLayers: typeof updateInputDataLayers
  validate: typeof validate
}

type Props = DispatchProps & ParentProps & OwnProps

interface State {}

const ConstrImportInputDataControlC = (props: Props) => {
  const getAttachmentsControl = () => {
    const adds: AttachmentInfos = {}
    if (props.inputData.file) {
      adds[props.inputData.file.name] = props.inputData.file
    }
    return (
      <div style={{margin: '5px'}}>
        <AttachmentsViewer
          attachments={{}}
          deletes={{}}
          updates={{}}
          adds={adds}
          acceptTypes={'.dxf'}
          maxNumber={1}
          onAttachmentsChange={changes => {
            const addedFiles = Object.keys(changes.adds)
            let file: AttachmentInfo | undefined
            if (addedFiles.length > 0) {
              file = changes.adds[addedFiles[0]]
            }
            props.updateInputData({...props.inputData, file: file})
          }}
          feature={new Feature({})}
          uploadToArchive={false}
        ></AttachmentsViewer>
      </div>
    )
  }

  const getExecuteButton = () => {
    return (
      <button
        type="button"
        className="button width"
        disabled={!props.inputData.file || !props.inputData.LocalityId}
        onClick={() => {
          props.validate()
        }}
      >
        Валидирай данните
      </button>
    )
  }

  const getLocationSelector = () => {
    return (
      <PlanSelector
        hidePlan={true}
        onPlanChange={p => {
          // props.updateInputData({...props.inputData, LocalityId: p ? p.getId() as number: 0})
        }}
        onSettlementsChange={(locs, settlement?: Feature, location?: Feature) => {
          props.updateInputData({
            ...props.inputData,
            settlement,
            location,
            LocalityId: location ? (location.getId() as number) : 0
          })
        }}
      />
    )
  }
  const getContainer = (content: JSX.Element, title: string | JSX.Element, margin?: string): JSX.Element => {
    return (
      <div style={{margin, display: 'flex'}}>
        <div style={{minWidth: '40%', maxWidth: '40%', display: 'flex', alignItems: 'center'}}>{title}</div>
        {content}
      </div>
    )
  }

  const getSuccess = () => {
    return (
      <div className="import-params-success">
        <div>Успешна валидация на входните параметри</div>
        <div>Номер на импорт: {props.inputData.startedImportGuid}</div>
      </div>
    )
  }
  const getValidationStatusUI = () => {
    if (props.inputData.loading) {
      if (props.inputData.startedImportGuid) {
        return getSuccess()
      }
      return <div className="import-loading">В процес на валидация на входните параметри...</div>
    } else {
      if (props.inputData.errors && props.inputData.errors.length > 0) {
        const errors: JSX.Element[] = []
        props.inputData.errors.forEach((e, i) => {
          errors.push(<div key={i}>{e}</div>)
        })
        return (
          <div className="import-params-errors">
            {errors}
            {props.inputData.errorDxf ? (
              <a style={{wordBreak: 'break-all'}} href={props.inputData.errorDxf}>
                {props.inputData.errorDxf}
              </a>
            ) : null}
          </div>
        )
      } else if (props.inputData.startedImportGuid) {
        return getSuccess()
      }
    }
  }

  return (
    <div style={{padding: '10px', boxSizing: 'border-box'} as React.CSSProperties}>
      <div style={{position: 'relative'}}>
        <OverlayLoader show={props.inputData.loading}></OverlayLoader>
        {getContainer(getAttachmentsControl(), 'Прикачете файл', `10px 0px`)}
        {getContainer(getLocationSelector(), 'Изберете местност', `10px 0px`)}
        {getExecuteButton()}
      </div>
      {getValidationStatusUI()}
    </div>
  )
}

const mapStoreToProps = (store: IAppStore) => ({
  inputData: store.constrImport.inputData,
  layerInfos: store.layerInfos.featureLayerInfos
})

export const ConstrImportInputDataControl = connect<OwnProps, DispatchProps, ParentProps>(mapStoreToProps, {
  ...appSourcesDispatcher,
  validate,
  updateInputData,
  updateInputDataLayers
})(ConstrImportInputDataControlC)
